/* ============================================================
   DERMIQ Bottle3D — canvas-rendered product bottle, exact detail
   Clear glass, amber gel, white pump, wrapped cylindrical label.
   Rotation driven externally via bottle.setRotation(rad).
   ============================================================ */
(function(){
  'use strict';

  function Bottle3D(canvas){
    this.cv = canvas;
    this.ctx = canvas.getContext('2d');
    this.rot = 0;
    this.dpr = Math.min(2, window.devicePixelRatio || 1);
    this.label = this._makeLabel();
    this._resize();
    var self=this;
    window.addEventListener('resize', function(){ self._resize(); self.draw(); });
  }

  Bottle3D.prototype.setRotation = function(rad){ this.rot = rad; this.draw(); };

  Bottle3D.prototype._resize = function(){
    var r = this.cv.getBoundingClientRect();
    this.cv.width  = Math.max(2, r.width  * this.dpr);
    this.cv.height = Math.max(2, r.height * this.dpr);
  };

  /* Label texture: white, thin rules, DERMIQ + serif title (as on photo) */
  Bottle3D.prototype._makeLabel = function(){
    var W = 1200, H = 640;                       // unrolled label
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var x = c.getContext('2d');
    x.fillStyle = '#ffffff'; x.fillRect(0,0,W,H);
    // thin horizontal rules
    x.strokeStyle = 'rgba(26,26,24,.25)'; x.lineWidth = 2;
    [8, 90, 330, 420, 500, 560, H-8].forEach(function(y){
      x.beginPath(); x.moveTo(0,y); x.lineTo(W,y); x.stroke();
    });
    var L = 60; // left margin of front panel
    x.fillStyle = '#000';
    x.font = '600 30px "Helvetica Neue", Arial, sans-serif';
    x.textBaseline = 'alphabetic';
    // brand
    x.save(); x.font='500 34px "Helvetica Neue", Arial, sans-serif';
    x.fillText('D E R M I Q', L, 62);
    x.font='300 17px "Helvetica Neue", Arial, sans-serif'; x.fillStyle='rgba(26,26,24,.55)';
    x.fillText('A D V A N C E D   S K I N C A R E', L, 84); x.restore();
    // title (serif, like photo)
    x.fillStyle = '#000';
    x.font = '500 92px "Palatino Linotype", Palatino, Georgia, serif';
    x.fillText('Antioxidant', L, 190);
    x.fillText('Ginkgo', L, 278);
    x.font = '400 54px "Palatino Linotype", Palatino, Georgia, serif';
    x.fillText('Gel Booster', L, 318);
    // key ingredients row
    x.font = '400 16px "Helvetica Neue", Arial, sans-serif'; x.fillStyle='rgba(26,26,24,.7)';
    x.fillText('GINKGO BILOBA EXTRACT   HYALURONIC ACID   NIACINAMIDE', L, 360);
    x.fillText('CENTELLA ASIATICA   ALLANTOIN   GLYCERIN', L, 384);
    // manifesto
    x.font = '400 19px "Helvetica Neue", Arial, sans-serif'; x.fillStyle='#000';
    x.fillText('You chose to protect your skin from within.', L, 448);
    x.fillText('You chose to invest in what lasts.', L, 474);
    x.fillStyle='rgba(26,26,24,.45)';
    x.fillText("That's what sets you apart.", L, 500);
    // volume
    x.font = '500 24px "Helvetica Neue", Arial, sans-serif'; x.fillStyle='#000';
    x.fillText('3 0  M L  /  1  F L . O Z .', L, 545);
    x.font='300 15px "Helvetica Neue", Arial, sans-serif'; x.fillStyle='rgba(26,26,24,.4)';
    x.fillText('Apply 1–3 drops to cleansed face. For gently until absorbed.', L, 590);
    return c;
  };

  Bottle3D.prototype.draw = function(){
    var cv=this.cv, g=this.ctx, W=cv.width, H=cv.height;
    g.clearRect(0,0,W,H);
    var cx = W/2;
    var bodyH = H*0.58, bodyW = Math.min(W*0.55, bodyH*0.52);
    var R = bodyW/2;
    var top = H*0.34, bot = top+bodyH;
    var sh = R*0.28; // shoulder curve

    // soft ground shadow
    g.save();
    g.fillStyle='rgba(26,26,24,.14)';
    g.beginPath(); g.ellipse(cx, bot+R*0.18, R*1.5, R*0.22, 0, 0, 7); g.fill();
    g.filter='none'; g.restore();

    // ---- glass body with amber gel ----
    var body = new Path2D();
    body.moveTo(cx-R, top+sh);
    body.quadraticCurveTo(cx-R, top, cx-R+sh, top);
    body.lineTo(cx+R-sh, top);
    body.quadraticCurveTo(cx+R, top, cx+R, top+sh);
    body.lineTo(cx+R, bot-sh*0.6);
    body.quadraticCurveTo(cx+R, bot, cx+R-sh*0.6, bot);
    body.lineTo(cx-R+sh*0.6, bot);
    body.quadraticCurveTo(cx-R, bot, cx-R, bot-sh*0.6);
    body.closePath();

    // amber gel gradient (deeper at edges = cylinder illusion)
    var amber = g.createLinearGradient(cx-R,0,cx+R,0);
    amber.addColorStop(0.00,'#8a5010');
    amber.addColorStop(0.12,'#c07d1e');
    amber.addColorStop(0.30,'#e8a83b');
    amber.addColorStop(0.46,'#f6c968');
    amber.addColorStop(0.60,'#eeb14a');
    amber.addColorStop(0.82,'#b56f16');
    amber.addColorStop(1.00,'#7c460c');
    g.save(); g.clip(body);
    g.fillStyle = amber; g.fillRect(cx-R, top, R*2, bodyH);
    // air gap at top of liquid
    g.fillStyle='rgba(255,252,246,.55)';
    g.fillRect(cx-R, top, R*2, bodyH*0.045);
    g.fillStyle=amber; g.globalAlpha=.35;
    g.fillRect(cx-R, top, R*2, bodyH*0.045); g.globalAlpha=1;

    // ---- wrapped label (cylindrical mapping) ----
    var lblTop = top + bodyH*0.34, lblH = bodyH*0.60;
    var tex = this.label, TW = tex.width;
    var circ = 2*Math.PI*R;                    // px circumference
    var scale = TW/circ*1.15;                  // texture px per surface px (label covers most of circumference)
    var rotPx = (this.rot % (2*Math.PI)) / (2*Math.PI) * TW;
    var strip = Math.max(2, Math.round(2*this.dpr));
    for (var sx = -R; sx < R; sx += strip){
      var phi = Math.asin((sx+strip/2)/R);      // angle on cylinder
      var u = rotPx + phi*R*scale + 330;   // +330: center front panel at rot 0
      u = ((u % TW)+TW)%TW;
      var w = Math.min(strip*scale*Math.max(.25, Math.cos(phi)), TW-u);
      // gap in wrap: label seam — leave 14% of texture as bare glass? keep full wrap (photo shows near-full wrap)
      g.drawImage(tex, u, 0, Math.max(1,w), tex.height,
                  cx+sx, lblTop, strip, lblH);
      // cylindrical shading on label
      var shade = 1-Math.cos(phi);
      g.fillStyle='rgba(26,26,24,'+(shade*0.32)+')';
      g.fillRect(cx+sx, lblTop, strip, lblH);
    }

    // glass side darkening + specular highlights over everything
    var glass = g.createLinearGradient(cx-R,0,cx+R,0);
    glass.addColorStop(0,'rgba(60,35,8,.5)');
    glass.addColorStop(.06,'rgba(255,255,255,.14)');
    glass.addColorStop(.13,'rgba(255,255,255,0)');
    glass.addColorStop(.5,'rgba(255,255,255,0)');
    glass.addColorStop(.86,'rgba(255,255,255,.10)');
    glass.addColorStop(.95,'rgba(255,255,255,0)');
    glass.addColorStop(1,'rgba(50,28,6,.55)');
    g.fillStyle=glass; g.fillRect(cx-R, top, R*2, bodyH);
    // vertical specular streak
    var spec = g.createLinearGradient(cx-R*0.62,0,cx-R*0.30,0);
    spec.addColorStop(0,'rgba(255,255,255,0)');
    spec.addColorStop(.5,'rgba(255,255,255,.5)');
    spec.addColorStop(1,'rgba(255,255,255,0)');
    g.fillStyle=spec; g.fillRect(cx-R*0.62, top+sh*0.4, R*0.32, bodyH-sh);
    g.restore();

    // glass rim outline
    g.strokeStyle='rgba(26,26,24,.18)'; g.lineWidth=1.2*this.dpr; g.stroke(body);

    // ---- white pump ----
    var nW=R*0.62, nH=H*0.075;                 // collar
    var pW=R*0.46, pH=H*0.16;                  // pump body
    var white = g.createLinearGradient(cx-pW,0,cx+pW,0);
    white.addColorStop(0,'#c9c5be'); white.addColorStop(.22,'#ffffff');
    white.addColorStop(.55,'#f4f2ee'); white.addColorStop(.8,'#e2ded7');
    white.addColorStop(1,'#b8b4ac');
    // collar
    g.fillStyle=white;
    g.fillRect(cx-nW, top-nH, nW*2, nH+2);
    g.beginPath(); g.ellipse(cx, top-nH, nW, nW*0.16, 0, Math.PI, 0); g.fill();
    // pump cylinder
    g.fillStyle=white;
    g.fillRect(cx-pW, top-nH-pH, pW*2, pH);
    // pump head: angled top with spout (like photo)
    var hd=new Path2D();
    var hy=top-nH-pH;
    hd.moveTo(cx-pW, hy);
    hd.lineTo(cx-pW, hy-pH*0.34);
    hd.quadraticCurveTo(cx-pW, hy-pH*0.62, cx-pW*0.35, hy-pH*0.66);
    hd.lineTo(cx+pW*0.15, hy-pH*0.52);      /* slanted crown */
    hd.quadraticCurveTo(cx+pW, hy-pH*0.34, cx+pW, hy-pH*0.1);
    hd.lineTo(cx+pW, hy);
    hd.closePath();
    g.fillStyle=white; g.fill(hd);
    g.strokeStyle='rgba(26,26,24,.10)'; g.lineWidth=1*this.dpr;
    g.stroke(hd);
    g.strokeRect(cx-pW, hy, pW*2, pH);
    g.strokeRect(cx-nW, top-nH, nW*2, nH);
  };

  window.DermiqBottle3D = Bottle3D;
})();
